import { createContext } from "react";

import { AccountMenu,EssentialsMenu, Shop } from "../../../../types";

export type MobileMenuContextValue = {
  isLoggedIn?: boolean;
  shops?: Shop[];
  essentialsMenu?: EssentialsMenu;
  accountMenu?: AccountMenu;
  cartItemsCount?: number;
  wishlistItemsCount?: number;
};

export const MobileMenuContext = createContext<MobileMenuContextValue>({
  isLoggedIn: false,
  shops: undefined,
  essentialsMenu: undefined,
  accountMenu: undefined,
  cartItemsCount: undefined,
  wishlistItemsCount: undefined,
});
